import { Component, Input, forwardRef, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';

export interface MultiselectOption {
  value: any;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectDropdownComponent),
      multi: true,
    },
  ],
})
export class MultiselectDropdownComponent
  implements OnInit, ControlValueAccessor
{
  @Input() label: string = 'Select';
  @Input() options: MultiselectOption[] = [];
  @Input() maxSelection: number = Infinity;
  @Input() isFilter: boolean = false;

  private cdr = inject(ChangeDetectorRef);
  value: any[] = [];

  onChange = (value: any[]) => {};
  onTouched = () => {};

  ngOnInit(): void {}

  writeValue(value: any[]): void {
    // Delay update to prevent ExpressionChanged error
    this.value = value || [];
    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  isOptionDisabled(val: any): boolean {
    return !this.value.includes(val) && this.value.length >= this.maxSelection;
  }

  onSelectionChange(event: any): void {
    let selected = event.value;
    if (selected.length > this.maxSelection) {
      selected.pop(); // remove the last selection
    }
    this.value = selected;
    this.onChange(this.value);
    this.onTouched();
  }
}
